import { render, staticRenderFns } from "./ShopItem.vue?vue&type=template&id=fc5f09e8&scoped=true"
import script from "./ShopItem.vue?vue&type=script&lang=js"
export * from "./ShopItem.vue?vue&type=script&lang=js"
import style0 from "./ShopItem.vue?vue&type=style&index=0&id=fc5f09e8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5f09e8",
  null
  
)

export default component.exports